// Nonmodal navigation: keep native commerce scripts untouched.
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-ov-menu][open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('[data-ov-menu][open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
    else if (event.target.closest('a')) menu.open = false;
  });
});
